import { toast } from "react-hot-toast";
import { useLocation } from "wouter";
import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useGangContext } from "./useGang.ts";

export function CopySharedGangDialog() {
  const { gang } = useGangContext();
  const [_, navigate] = useLocation();

  return (
    <ConfirmDialog
      heading="Copy shared gang?"
      description={`${gang.name} will be copied over to your own gangs list.`}
      submitLabel="Copy over"
      onSubmit={() => database.gangs.duplicateOne(gang)}
      onSuccess={(gangId) => {
        toast("Gang copied");
        navigate(`~/gangs/g/${gangId}`);
      }}
    />
  );
}
